'use strict';

class StatesTemplatesController {
  /* @ngInject */
  constructor(StatesTemplatesService, $scope, $q) {
    Object.assign(this, { StatesTemplatesService, $scope, $q });

    this.query = {
      limit: 25,
      page: 1
    };
    //this.statesTemplates = $scope.$parent.$resolve.statesTemplates;
    this.getStatesTemplates();

    this.onPagination = () => {
      this.getStatesTemplates();
    };

    this.clientIds = null;
  }

  getStatesTemplates() {
    let opts = {
      page: this.query.page,
      limit: this.query.limit,
      where: {},
      include: []
    };

    let queryReady = this.StatesTemplatesService.getModels(opts).then(
      statesTemplates => {
        this.statesTemplates = statesTemplates;
      }
    );
    let countReady = this.StatesTemplatesService.getCount(opts).then(result => {
      this.statesTemplatesCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default StatesTemplatesController;
